import { Location } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  CampaignManagerVoucherOfferModel,
  CampaignV2OffersQuery,
  CampaignV2OffersService,
  DATE_OPTIONS,
  DateOptions,
} from '@fgb/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-campaign-v2-details-voucher-page',
  templateUrl: './campaign-v2-details-voucher-page.component.html',
  styleUrls: ['./campaign-v2-details-voucher-page.component.scss'],
})
export class CampaignV2DetailsVoucherPageComponent implements OnInit, OnDestroy {
  currentCampaign: CampaignManagerVoucherOfferModel | any;
  campaignOfferSub: Subscription;
  isDateExpired: boolean = false;
  isDisplayUntilDateExpired: boolean = false;
  screenSize = ScreenType;

  constructor(
    @Inject(DATE_OPTIONS) public dateOption: DateOptions,
    private route: ActivatedRoute,
    private campaignV2OffersService: CampaignV2OffersService,
    private campaignV2OffersQuery: CampaignV2OffersQuery,
    private location: Location
  ) {}

  ngOnInit() {
    let voucherId = +(this.route.snapshot.paramMap.get('voucherId') || '0');
    this._updateVoucher(voucherId);
  }

  ngOnDestroy(): void {
    this.campaignOfferSub.unsubscribe();
  }

  _updateVoucher(voucherId: number) {
    if (!!voucherId) {
      firstValueFrom(this.campaignV2OffersService.fetchV2Offers()).then(() => {
        this.campaignOfferSub = this.campaignV2OffersQuery.selectFirst().subscribe((campaignOffer) => {
          if (campaignOffer) {
            for (let voucher of campaignOffer?.Vouchers) {
              if (voucher.CampaignId === voucherId) {
                this.currentCampaign = voucher;
                this.isDateExpired = new Date(this.currentCampaign.ExpiryDate) < new Date();
                this.isDisplayUntilDateExpired = new Date(this.currentCampaign.DisplayUntilDate) < new Date();
                break;
              }
            }
          }
        });
      });
    }
  }

  goBack() {
    this.location.back();
  }
}
